import { render, staticRenderFns } from "./confirmPayment.vue?vue&type=template&id=bdb6f6c8&scoped=true&"
import script from "./confirmPayment.vue?vue&type=script&lang=js&"
export * from "./confirmPayment.vue?vue&type=script&lang=js&"
import style0 from "./confirmPayment.vue?vue&type=style&index=0&id=bdb6f6c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb6f6c8",
  null
  
)

export default component.exports